import React, { useEffect, useState } from 'react';
import { api, BASE_URL } from '../utils/api';
import type { Question } from '../types';

export default function AdminMusics() {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    const all = await api.get<Question[]>('/api/questions');
    setQuestions(all);
    setLoading(false);
  };

  const withAudio = questions.filter((q) => q.audioFile);

  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div className="page-content">
      <div className="page-header">
        <h2>Musiques ({withAudio.length} fichiers)</h2>
      </div>
      <p className="text-muted">Pour uploader ou modifier un fichier audio, utilisez la section "Modifier" d'une question dans l'onglet Questions.</p>

      {withAudio.length === 0 ? (
        <div className="empty-state">Aucune musique uploadée</div>
      ) : (
        <div className="musics-list">
          {withAudio.map((q) => (
            <div key={q.id} className="music-card card">
              <div className="music-card-info">
                <strong>{q.title}</strong>
                <span className="text-muted">{q.audioFile}</span>
              </div>
              <div className="music-segment">
                Segment : {(q.startMs / 1000).toFixed(1)}s → {(q.endMs / 1000).toFixed(1)}s
              </div>
              <audio
                controls
                src={`${BASE_URL}/api/musics/stream/${q.audioFile}`}
                style={{ width: '100%', marginTop: 8 }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
